import React, { ReactElement, useState } from 'react';
import './dropdown.scss';
import { Button } from 'idsk-react-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import AssignMePripomienkaListButton from './AssignMePripomienkaListButton';
import Uuid from '../../../model/Uuid';
import SendBezPripomienokButton from './SendBezPripomienokButton';
import SendPripomienkyButton from './SendPripomienkyButton';
import ExportPripomienokButton from './ExportPripomienokButton';
import AddPripomienkaButton from './AddPripomienkaButton';
import AddHromadnaPripomienkaButton from './AddHromadnaPripomienkaButton';
import SendBezPripomienokAdminButton from './admin/SendBezPripomienokAdminButton';
import AddPripomienkaAdminButton from './admin/AddPripomienkaAdminButton';
import AddHromadnaPripomienkaAdminButton from './admin/AddHromadnaPripomienkaAdminButton';
import ExportPripomienokPredkladatelButton from './ExportPripomienokPredkladatelButton';
import HromadneVyhodnotitButton from './HromadneVyhodnotitButton';
import NahladVyhodnoteniaPkButton from './NahladVyhodnoteniaPkButton';

interface Props {
  title: string,

  reloadSubjektBezPripomienokList?(): void

  reloadPripomienkyList?(): void

  reloadFilterData?(): void

  assignedList?: Array<Uuid>;
  setAssignedList?: (assignedList: Array<Uuid>) => void;
}

const Dropdown = ({
  title,
  assignedList,
  setAssignedList,
  reloadSubjektBezPripomienokList,
  reloadPripomienkyList,
  reloadFilterData,
}: Props): ReactElement => {
  const onClick = (): void => {
    setOpenDropdown(open => !open);
  };

  const [open, setOpenDropdown] = useState<boolean>(false);
  const drop = React.useRef(null);
  const ulRef = React.useRef(null);
  const [isButtonVisible, setIsButtonVisible] = useState<boolean>(false);
  const dropdownClass: string = open ? 'dropdown-card' : 'dropdown-card-hidden';

  const handleClick = (e: MouseEvent): void => {
    if (drop.current && !drop.current.contains(e.target)) {
      setOpenDropdown(false);
    }
  };

  React.useEffect(() => {
    if (ulRef.current?.children.length > 0 && !isButtonVisible) {
      setIsButtonVisible(true);
    }
    document.addEventListener('mousedown', handleClick);
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, [drop, isButtonVisible]);

  return (
    <div ref={drop} className="dropdown">
      {isButtonVisible && (
        <Button onClick={onClick} className="dropdown-button">
          <FontAwesomeIcon icon={faBars} />
          <div className="button-inline-text">{title}</div>
        </Button>
      )}
      <div className={dropdownClass}>
        <ul ref={ulRef} className="simple-list">
          <AddPripomienkaButton setOpenDropdown={setOpenDropdown} />
          <AddPripomienkaAdminButton setOpenDropdown={setOpenDropdown} />
          <AddHromadnaPripomienkaButton setOpenDropdown={setOpenDropdown} />
          <AddHromadnaPripomienkaAdminButton setOpenDropdown={setOpenDropdown} />
          <SendPripomienkyButton setOpenDropdown={setOpenDropdown} />
          <SendBezPripomienokButton
            reloadSubjektBezPripomienokList={reloadSubjektBezPripomienokList}
            reloadFilterData={reloadFilterData}
            setOpenDropdown={setOpenDropdown}
          />
          <ExportPripomienokButton setOpenDropdown={setOpenDropdown} />
          <ExportPripomienokPredkladatelButton setOpenDropdown={setOpenDropdown} />
          <NahladVyhodnoteniaPkButton
            buttonName="Náhľad pre vyhodnotenie PK"
            setOpenDropdown={setOpenDropdown}
          />
          <AssignMePripomienkaListButton
            assignedList={assignedList}
            setAssignedList={setAssignedList}
            reloadPripomienkaList={reloadPripomienkyList}
            reloadFilterData={reloadFilterData}
            setOpenDropdown={setOpenDropdown}
          />
          <HromadneVyhodnotitButton
            assignedList={assignedList}
            setAssignedList={setAssignedList}
            setOpenDropdown={setOpenDropdown}
          />
          <SendBezPripomienokAdminButton />
        </ul>
      </div>
    </div>
  );
};

export default Dropdown;
